import axios from '@/axios.config.js';

class TicketService {

    listTicket(cancelToken) {
        return axios
            .get('tickets', {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    createTicket(cancelToken, data) {
        return axios
            .post('tickets', {
                title: data.title,
                category_id: data.categoryId
            }, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    closeTicket(cancelToken, ticketId) {
        return axios
            .post(`tickets/${ticketId}/!close`, {}, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    listCategory(cancelToken) {
        return axios
            .get('tickets/categories', {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    createCategory(cancelToken, data) {
        return axios
            .post('tickets/categories', {title: data.title,}, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    listMessage(cancelToken, ticketId) {
        return axios
            .get(`tickets/${ticketId}/sub-tickets`, {cancelToken: cancelToken.token,})
            .then(response => {
                return response.data;
            });
    }

    newMessage(cancelToken, ticketId, data) {
        return axios
            .post(`tickets/${ticketId}/sub-tickets`, {content: data.content}, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }
}

export default new TicketService();